import { render, staticRenderFns } from "./create-form.vue?vue&type=template&id=f20d0c7c&scoped=true"
import script from "./create-form.vue?vue&type=script&lang=js"
export * from "./create-form.vue?vue&type=script&lang=js"
import style0 from "./create-form.vue?vue&type=style&index=0&id=f20d0c7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f20d0c7c",
  null
  
)

export default component.exports